
//table表格组件头部标题统一管理

const tables_title_zh = {
  account:'账号',
  name:'名称',
  dept:'部门',
  position:'职位',
  phone:'电话',
  create_time:'创建时间',
  update_time:'更新时间',
  status:'状态',
  assign_roles:'分配角色',
  reset_password:'重置密码',
  dept_assign:'可见部门分配',
  birthday:'出生日期',
  password:'密码',
  repeat_password:'重复密码',
  email:'邮箱',
  sex:'性别',
  male:'男',
  female:'女',
  wx:'微信号',
  address: '家庭住址',
  patientName: '姓名',
  //roles
  superior_role:'上级角色',
  alias:'别名',
  sort:'排序',
  //dept
  simple_name:'部门简称',
  full_name:'部门全称',
  remarks:'备注',
  superior_name:'上级名称',
  //posts
  posts_name:'职位名称',
  posts_code:'职位编码',
  //dict_type
  dict_type:'字典类型',
  sys_type:'系统类型',
  non_sys_type:'非系统类型',
  enable:'启用',
  disable:'禁用',
  type_name:'类型名称',
  type_code:'类型编码',
  sys_dict:'是否是系统字典',
  dict_desc:'字典描述',
  yes:'是',
  no:'否',
  dict_name:'字典名称',
  dict_code:'字典编码',
  super_dict:'上级字典',
  //menus
  level:'层级',
  menu:'是否是菜单',
  menu_name:'菜单名称',
  menu_code:'菜单编码',
  parent_num:'父级编号',
  req_addr:'请求地址',

  //login_log
  log_name:'日志名称',
  user_name:'用户名称',

  log_type:'日志类型',
  log_class:'类名',
  log_method:'方法名',
  exception_log:'异常日志',
  business_log:'业务日志',

  //messages
  title:'标题',
  content:'内容',
  creater_name:'创建者',

  //tenant
  tenant_name:'租户名称',
  tenant_code:'租户编码',
  update_name:'更新者',
  database_name:'数据库名称',

  scale_name: '量表名称',
  model_name: '模型名称',
  report_name: '报告名称',
  model_issue_state: '发布状态',
  evaluation_name:'测评名称',
  evaluation_time:'测评时间',

  identity_ard: '身份证',
  index_name: '指标名称',

  mobile_phone_number: '手机号码',
  var_name: '变量名',
  relevance_topic_or_index: '关联题目/指标',
  relevance_topic_type: '关联题目类型',
  common_model: '常用模型',
  project_name: '项目名称',
  project_id: '项目id',
  tag: '标签',
  questionnaire_list:'流调列表',
  color:'颜色',
  submitNumber: '填报次数',

  label_type_name: "标签名称",
  //  management 管理
  importPatients:'导入患者信息',
}

export default tables_title_zh



// WEBPACK FOOTER //
// ./src/common/lang/tables_title/tables_title_zh.js